// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__Zijsc","itemTitle":"ClientEmergencyInfo_itemTitle__2C8RW","itemText":"ClientEmergencyInfo_itemText__vBJl5"};